(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-story-block"] && !Shopify.designMode) return;
  try {
    
  // Editorial Story Block: scroll-entrance reveal + optional subtle parallax.
  // Runs once for the compiled asset, so every instance on the page is
  // looked up by class (Liquid/section.id isn't available in this tag).
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('.editorial-story');
    if (!sections.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      var animationsEnabled = section.dataset.animations === 'true' && !reduceMotion;
      var parallaxEnabled = section.dataset.parallax === 'true' && !reduceMotion;
      var parallaxTarget = section.querySelector('.editorial-story__media-inner');

      // Nothing to observe: just make sure content is visible and bail.
      if ((!animationsEnabled && !parallaxEnabled) || !('IntersectionObserver' in window)) {
        section.classList.add('is-in-view');
        return;
      }

      var ticking = false;
      var isIntersecting = false;

      function updateParallax() {
        ticking = false;
        if (!isIntersecting || !parallaxTarget) return;

        var rect = section.getBoundingClientRect();
        var viewportCenter = window.innerHeight / 2;
        var distanceFromCenter = rect.top + rect.height / 2 - viewportCenter;
        var offset = Math.max(-24, Math.min(24, distanceFromCenter * -0.06));

        parallaxTarget.style.transform = 'translateY(' + offset.toFixed(2) + 'px)';
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateParallax);
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            isIntersecting = entry.isIntersecting;

            if (entry.isIntersecting) {
              if (animationsEnabled) section.classList.add('is-in-view');

              if (parallaxEnabled) {
                updateParallax();
                window.addEventListener('scroll', onScroll, { passive: true });
              }
            } else if (parallaxEnabled) {
              window.removeEventListener('scroll', onScroll);
            }
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-capture"] && !Shopify.designMode) return;
  try {
    
  // Email Capture: shows a loading state the moment a valid submission is
  // sent. The actual success/error UI comes from the server-rendered form
  // state after the page reloads — this only covers the brief in-flight gap.
  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('.email-capture__form');

    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var button = form.querySelector('.email-capture__submit');
        if (!button || button.disabled) return;

        var label = button.querySelector('.email-capture__submit-text');
        if (label) label.textContent = 'Subscribing...';

        button.disabled = true;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-premium"]) return;
  try {
    
  // Footer Premium: accessible accordion toggle (mobile) + auto-submitting
  // localization selects. Both are intentionally tiny — the accordion's
  // open/close animation itself is a pure CSS grid-template-rows transition;
  // this only flips the state that CSS reacts to.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.footer__accordion-trigger').forEach(function (trigger) {
      var heading = trigger.closest('h3');
      var panel = heading ? heading.nextElementSibling : null;

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.classList.toggle('footer__accordion-panel--open', !expanded);
      });
    });

    document.querySelectorAll('.footer__select--auto-submit').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  // Hero Carousel: initializes one Swiper instance per section instance.
  // Runs once for the compiled asset, so every instance on the page is
  // looked up by class/data attribute (Liquid/section.id isn't available
  // in this tag). Falls back to a static first-slide view if Swiper isn't
  // present on the page.
  (function () {
    var desktopMql = window.matchMedia('(min-width: 750px)');

    function getVisibleVideo(slide) {
      if (!slide) return null;
      var selector = desktopMql.matches ? '.hero-carousel__video.is-desktop' : '.hero-carousel__video.is-mobile';
      return slide.querySelector(selector);
    }

    function pauseSlideVideos(slide) {
      if (!slide) return;
      var videos = slide.querySelectorAll('.hero-carousel__video');
      videos.forEach(function (video) {
        video.pause();
      });
    }

    function playSlideVideo(slide) {
      var video = getVisibleVideo(slide);
      if (!video) return;

      if (video.dataset.loaded !== 'true') {
        video.load();
        video.dataset.loaded = 'true';
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function initHeroCarousels() {
      var roots = document.querySelectorAll('.hero-carousel[data-height]');

      roots.forEach(function (root) {
        if (root.dataset.hcInitialized === 'true') return;

        var viewport = root.querySelector('.hero-carousel__viewport[data-carousel]');
        if (!viewport) return;

        root.dataset.hcInitialized = 'true';

        var slides = root.querySelectorAll('.hero-carousel__slide');
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function syncActiveSlideMedia() {
          var activeSlide = root.querySelector('.hero-carousel__slide.swiper-slide-active');

          slides.forEach(function (slide) {
            if (slide !== activeSlide) pauseSlideVideos(slide);
          });

          if (activeSlide && !reduceMotion) playSlideVideo(activeSlide);
        }

        if (typeof Swiper === 'undefined') {
          root.classList.add('hc-static');
          if (slides[0]) {
            slides[0].classList.add('swiper-slide-active');
            if (!reduceMotion) playSlideVideo(slides[0]);
          }
          return;
        }

        var dataset = viewport.dataset;
        var paginationEl = root.querySelector('.hero-carousel__pagination');
        var nextEl = root.querySelector('.hero-carousel__nav--next');
        var prevEl = root.querySelector('.hero-carousel__nav--prev');
        var scrollbarEl = root.querySelector('.hero-carousel__scrollbar');

        var config = {
          loop: dataset.loop === 'true' && slides.length > 1,
          speed: parseInt(dataset.speed, 10) || 700,
          spaceBetween: parseInt(dataset.gap, 10) || 0,
          centeredSlides: dataset.centered === 'true',
          allowTouchMove: dataset.touch !== 'false',
          effect: dataset.effect === 'fade' ? 'fade' : 'slide',
          fadeEffect: { crossFade: true },
          watchSlidesProgress: true,
          a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
          },
          keyboard: {
            enabled: dataset.keyboard === 'true',
            onlyInViewport: true,
          },
          mousewheel: {
            enabled: dataset.mousewheel === 'true',
            forceToAxis: true,
          },
        };

        if (dataset.autoplay === 'true' && slides.length > 1) {
          config.autoplay = {
            delay: (parseInt(dataset.autoplaySpeed, 10) || 5) * 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: dataset.pauseOnHover === 'true',
          };
        }

        if (paginationEl) {
          config.pagination = {
            el: paginationEl,
            clickable: true,
            type: dataset.paginationStyle || 'bullets',
          };
        }

        if (nextEl && prevEl) {
          config.navigation = { nextEl: nextEl, prevEl: prevEl };
        }

        if (scrollbarEl) {
          config.scrollbar = { el: scrollbarEl, draggable: true };
        }

        var swiper = new Swiper(viewport, config);

        swiper.on('init', syncActiveSlideMedia);
        swiper.on('slideChangeTransitionEnd', syncActiveSlideMedia);
        syncActiveSlideMedia();

        var handleBreakpointChange = function () {
          syncActiveSlideMedia();
        };

        if (desktopMql.addEventListener) {
          desktopMql.addEventListener('change', handleBreakpointChange);
        } else if (desktopMql.addListener) {
          desktopMql.addListener(handleBreakpointChange);
        }

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!swiper.autoplay || !swiper.autoplay.running === undefined) return;
                if (entry.isIntersecting) {
                  if (dataset.autoplay === 'true') swiper.autoplay.start();
                } else if (swiper.autoplay.stop) {
                  swiper.autoplay.stop();
                }
              });
            },
            { threshold: 0.15 }
          );
          observer.observe(root);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroCarousels);
    } else {
      initHeroCarousels();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('.hero-carousel[data-height]')) {
        initHeroCarousels();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || '${{amount}}';

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision === undefined ? 2 : precision;
        thousands = thousands === undefined ? ',' : thousands;
        decimal = decimal === undefined ? '.' : decimal;
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsPart = parts[1] ? decimal + parts[1] : '';
        return dollars + centsPart;
      }

      var match = formatString.match(placeholderRegex);
      var key = match ? match[1] : 'amount';

      switch (key) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getShopifyRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function cdnImage(url, width) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?width=' + width : '&width=' + width);
    }

    function safeParseJSON(text, fallback) {
      if (!text) return fallback;
      try {
        return JSON.parse(text);
      } catch (error) {
        console.warn('[Shop the Look] Failed to parse product variant JSON:', error);
        return fallback;
      }
    }

    var ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
        return ESCAPE_MAP[char];
      });
    }

    /* -----------------------------------------------------------------------
     * ShopTheLookCart — stateless cart AJAX wrapper.
     *
     * Shared across every <shop-the-look-section> instance because there is
     * exactly one Shopify cart on the storefront, but this object never
     * remembers which section, card, or button called it. It only knows how
     * to talk to /cart.js, /cart/add.js and /cart/change.js.
     * --------------------------------------------------------------------- */
    var ShopTheLookCart = {
      getCart: function (signal) {
        return fetch(getShopifyRoot() + 'cart.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
          signal: signal,
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to fetch cart.');
          return response.json();
        });
      },

      addItems: function (items, signal) {
        var validItems = (items || []).filter(function (item) {
          var id = Number(item && item.id);
          return Number.isInteger(id) && id > 0;
        });

        if (!validItems.length) return Promise.reject(new Error('No valid items to add.'));

        return fetch(getShopifyRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: validItems.map(function (item) {
              return { id: Number(item.id), quantity: Math.max(1, Number(item.quantity) || 1) };
            }),
          }),
          signal: signal,
        }).then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              if (!response.ok) {
                throw new Error((data && (data.description || data.message)) || 'Unable to add item(s) to your cart.');
              }
              return data;
            });
        });
      },

      changeLine: function (key, quantity, signal) {
        return fetch(getShopifyRoot() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) }),
          signal: signal,
        }).then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              if (!response.ok) {
                throw new Error((data && (data.description || data.message)) || 'Unable to update your cart.');
              }
              return data;
            });
        });
      },
    };

    /* -----------------------------------------------------------------------
     * ThemeCartBridge — best-effort, stateless integration with whatever cart
     * UI the surrounding theme already ships. Every method is defensive: a
     * missing/unknown theme hook is a no-op, never a thrown error, and never
     * something specific to one Shop the Look section.
     * --------------------------------------------------------------------- */
    var KNOWN_DRAWER_SELECTORS = [
      'cart-drawer',
      'cart-notification',
      '#CartDrawer',
      '#cart-drawer',
      '[data-cart-drawer]',
      '.cart-drawer',
      '.drawer--cart',
    ];

    var ThemeCartBridge = {
      updateCartCount: function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        document
          .querySelectorAll(
            '[data-cart-count], .cart-count, .cart-count-bubble, #cart-icon-bubble, [data-cart-item-count]'
          )
          .forEach(function (el) {
            el.textContent = String(count);
          });
      },

      dispatchCartEvents: function (cart) {
        ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
        });
      },

      findDrawer: function () {
        for (var i = 0; i < KNOWN_DRAWER_SELECTORS.length; i++) {
          var el = document.querySelector(KNOWN_DRAWER_SELECTORS[i]);
          if (el) return el;
        }
        return null;
      },

      hasDrawer: function () {
        return !!this.findDrawer();
      },

      openDrawer: function () {
        var drawer = this.findDrawer();
        if (!drawer) return false;
        try {
          if (typeof drawer.open === 'function') {
            drawer.open();
            return true;
          }
          if (typeof drawer.show === 'function') {
            drawer.show();
            return true;
          }
          drawer.removeAttribute('hidden');
          drawer.classList.add('active', 'is-open', 'open');
          return true;
        } catch (error) {
          console.warn('[Shop the Look] Could not open the theme cart drawer:', error);
          return false;
        }
      },

      notify: function (cart) {
        this.updateCartCount(cart);
        this.dispatchCartEvents(cart);
      },
    };

    /* -----------------------------------------------------------------------
     * FallbackCartDrawer — lazily-built, page-level singleton used ONLY when
     * ThemeCartBridge can't find a theme cart drawer to talk to. It holds no
     * state belonging to any Shop the Look section; sections only ever call
     * FallbackCartDrawer.open(cart, moneyFormat).
     * --------------------------------------------------------------------- */
    var FallbackCartDrawer = {
      built: false,

      ensureBuilt: function () {
        if (this.built) return;
        this.built = true;

        var root = getShopifyRoot();
        var wrap = document.createElement('div');
        wrap.className = 'stl-fallback-cart';
        wrap.innerHTML =
          '<div class="stl-fallback-cart__overlay" data-stl-fallback-overlay hidden></div>' +
          '<aside class="stl-fallback-cart__drawer" data-stl-fallback-drawer role="dialog" aria-modal="true" aria-label="Your cart" hidden>' +
          '<div class="stl-fallback-cart__header">' +
          '<h2 class="stl-fallback-cart__title">Your Cart</h2>' +
          '<button type="button" class="stl-fallback-cart__close" data-stl-fallback-close aria-label="Close cart">&times;</button>' +
          '</div>' +
          '<div class="stl-fallback-cart__body" data-stl-fallback-body></div>' +
          '<div class="stl-fallback-cart__footer" data-stl-fallback-footer hidden>' +
          '<div class="stl-fallback-cart__subtotal-row">' +
          '<span>Subtotal</span><span data-stl-fallback-subtotal></span>' +
          '</div>' +
          '<a class="stl-fallback-cart__view" href="' +
          root +
          'cart">View Cart</a>' +
          '<a class="stl-fallback-cart__checkout" href="' +
          root +
          'cart/checkout">Checkout</a>' +
          '</div>' +
          '</aside>';
        document.body.appendChild(wrap);

        this.overlay = wrap.querySelector('[data-stl-fallback-overlay]');
        this.drawer = wrap.querySelector('[data-stl-fallback-drawer]');
        this.body = wrap.querySelector('[data-stl-fallback-body]');
        this.footer = wrap.querySelector('[data-stl-fallback-footer]');
        this.subtotalEl = wrap.querySelector('[data-stl-fallback-subtotal]');
        this.closeButton = wrap.querySelector('[data-stl-fallback-close]');

        var self = this;
        this.closeButton.addEventListener('click', function () {
          self.close();
        });
        this.overlay.addEventListener('click', function () {
          self.close();
        });
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && self.isOpen()) self.close();
        });
      },

      isOpen: function () {
        return this.built && this.drawer && !this.drawer.hidden;
      },

      render: function (cart, moneyFormat) {
        var items = (cart && cart.items) || [];
        this.body.innerHTML = items.length
          ? items
              .map(function (item) {
                var title = escapeHtml(item.product_title || item.title || '');
                var variant =
                  item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : '';
                var image = cdnImage(item.image, 160);
                return (
                  '<div class="stl-fallback-cart__item">' +
                  (image
                    ? '<img class="stl-fallback-cart__item-image" src="' +
                      escapeHtml(image) +
                      '" alt="" loading="lazy" width="64" height="64">'
                    : '') +
                  '<div class="stl-fallback-cart__item-body">' +
                  '<p class="stl-fallback-cart__item-title">' +
                  title +
                  '</p>' +
                  (variant ? '<p class="stl-fallback-cart__item-variant">' + variant + '</p>' : '') +
                  '<p class="stl-fallback-cart__item-line">' +
                  Number(item.quantity) +
                  ' &times; ' +
                  formatMoney(item.final_price, moneyFormat) +
                  '</p>' +
                  '</div>' +
                  '</div>'
                );
              })
              .join('')
          : '<p class="stl-fallback-cart__empty">Your cart is empty.</p>';

        this.footer.hidden = items.length === 0;
        if (this.subtotalEl) {
          this.subtotalEl.textContent = formatMoney(cart && cart.total_price, moneyFormat);
        }
      },

      open: function (cart, moneyFormat) {
        this.ensureBuilt();
        this.render(cart, moneyFormat);
        this.drawer.hidden = false;
        this.overlay.hidden = false;
        document.body.classList.add('cart-drawer-open');
        if (window.FreeShippingBar && typeof window.FreeShippingBar.setDrawerOpen === 'function') {
          window.FreeShippingBar.setDrawerOpen(true);
        }
        var drawer = this.drawer;
        var overlay = this.overlay;
        window.requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          overlay.classList.add('is-open');
        });
      },

      close: function () {
        if (!this.built) return;
        this.drawer.classList.remove('is-open');
        this.overlay.classList.remove('is-open');
        document.body.classList.remove('cart-drawer-open');
        if (window.FreeShippingBar && typeof window.FreeShippingBar.setDrawerOpen === 'function') {
          window.FreeShippingBar.setDrawerOpen(false);
        }
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var drawer = this.drawer;
        var overlay = this.overlay;
        window.setTimeout(
          function () {
            drawer.hidden = true;
            overlay.hidden = true;
          },
          reducedMotion ? 0 : 250
        );
      },
    };

    /* -----------------------------------------------------------------------
     * <shop-the-look-section> — one independent instance per section on the
     * page. Every property below lives on `this`; nothing is shared between
     * instances.
     * --------------------------------------------------------------------- */
    function defineShopTheLookSection() {
      class ShopTheLookSectionElement extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
          this.enableFallbackCart = this.dataset.enableCartFallback === 'true';
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this._timers = new Set();
          this._abortController = new AbortController();

          var self = this;
          this._sectionUnloadHandler = function (event) {
            if (event.target && typeof event.target.contains === 'function' && event.target.contains(self)) {
              self.teardown();
            }
          };
          this._sectionLoadHandler = function (event) {
            if (
              !self.initialized &&
              event.target &&
              typeof event.target.contains === 'function' &&
              event.target.contains(self)
            ) {
              self.connectedCallback();
            }
          };
          this._blockSelectHandler = function (event) {
            var blockId = event && event.detail && event.detail.blockId;
            if (!blockId) return;
            var card = self.querySelector('[data-stl-card][data-stl-id="' + CSS.escape(blockId) + '"]');
            if (!card) return;
            self.activate(blockId, { scrollCard: true });
          };
          this._blockDeselectHandler = function () {
            self.clearActive();
          };

          document.addEventListener('shopify:section:unload', this._sectionUnloadHandler);
          document.addEventListener('shopify:section:load', this._sectionLoadHandler);
          document.addEventListener('shopify:block:select', this._blockSelectHandler);
          document.addEventListener('shopify:block:deselect', this._blockDeselectHandler);

          this.cards = Array.from(this.querySelectorAll('[data-stl-card]'));
          this.hotspots = Array.from(this.querySelectorAll('[data-stl-hotspot]'));
          this.addAllButton = this.querySelector('[data-stl-add-all]');
          this.totalEl = this.querySelector('[data-stl-total]');
          this.toastEl = this.querySelector('[data-stl-toast]');
          this.imageWrap = this.querySelector('[data-stl-image-wrap]');

          this.cards.forEach(function (card) {
            self.initCard(card);
          });

          this.hotspots.forEach(function (hotspot) {
            hotspot.addEventListener('click', function () {
              self.activate(hotspot.dataset.stlTarget, { scrollCard: true });
            });
          });

          if (this.addAllButton) {
            this.addAllButton.addEventListener('click', function () {
              self.addAllToCart();
            });
          }

          this.updateTotal();
        }

        disconnectedCallback() {
          this.teardown();
        }

        teardown() {
          if (!this.initialized) return;
          this.initialized = false;

          document.removeEventListener('shopify:section:unload', this._sectionUnloadHandler);
          document.removeEventListener('shopify:section:load', this._sectionLoadHandler);
          document.removeEventListener('shopify:block:select', this._blockSelectHandler);
          document.removeEventListener('shopify:block:deselect', this._blockDeselectHandler);

          this._abortController.abort();
          this._timers.forEach(function (id) {
            window.clearTimeout(id);
          });
          this._timers.clear();
        }

        _setTimeout(fn, delay) {
          var self = this;
          var id = window.setTimeout(function () {
            self._timers.delete(id);
            fn();
          }, delay);
          this._timers.add(id);
          return id;
        }

        initCard(card) {
          var self = this;
          var variantsScript = card.querySelector('[data-stl-variants]');
          card.__variants = safeParseJSON(variantsScript && variantsScript.textContent, []);

          card.addEventListener('click', function (event) {
            if (event.target.closest('button, select, input, a')) return;
            self.activate(card.dataset.stlId, { scrollHotspot: true });
          });

          var optionSelects = Array.from(card.querySelectorAll('[data-stl-option]'));
          optionSelects.forEach(function (select) {
            select.addEventListener('change', function () {
              self.onVariantChange(card, optionSelects);
            });
          });

          // Theme-editor-only merchant control. This intentionally changes only
          // the live preview; a section script cannot write section settings.
          // The selected ID is exposed so the merchant can copy it into the
          // "Default variant ID" block setting to persist it.
          var editorSelect = card.querySelector('[data-stl-editor-default-variant-select]');
          if (editorSelect) {
            editorSelect.addEventListener('change', function () {
              var variantId = String(editorSelect.value || '');
              var variant = card.__variants.find(function (item) {
                return String(item.id) === variantId;
              });
              if (!variant) return;

              self.applyVariant(card, variant);
              self.syncOptionSelectorsToVariant(card, variant);
              var idOutput = card.querySelector('[data-stl-editor-default-variant-id]');
              if (idOutput) idOutput.textContent = variant.id;
              self.updateTotal();
            });
          }

          var qtyInput = card.querySelector('[data-stl-qty-input]');
          var qtyDecrease = card.querySelector('[data-stl-qty-decrease]');
          var qtyIncrease = card.querySelector('[data-stl-qty-increase]');
          if (qtyInput) {
            var changeQty = function (delta) {
              var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
              qtyInput.value = next;
              self.updateTotal();
            };
            if (qtyDecrease)
              qtyDecrease.addEventListener('click', function () {
                changeQty(-1);
              });
            if (qtyIncrease)
              qtyIncrease.addEventListener('click', function () {
                changeQty(1);
              });
            qtyInput.addEventListener('change', function () {
              var next = Math.max(1, parseInt(qtyInput.value, 10) || 1);
              qtyInput.value = next;
              self.updateTotal();
            });
          }

          var addButton = card.querySelector('[data-stl-add]');
          if (addButton) {
            addButton.addEventListener('click', function () {
              self.addSingleToCart(card, addButton);
            });
          }
        }

        findMatchingVariant(card, values) {
          return card.__variants.find(function (variant) {
            return values.every(function (value, index) {
              return variant['option' + (index + 1)] === value;
            });
          });
        }

        syncOptionSelectorsToVariant(card, variant) {
          if (!variant) return;
          Array.from(card.querySelectorAll('[data-stl-option]')).forEach(function (select) {
            var position = Number(select.dataset.optionPosition);
            var value = variant['option' + position];
            if (value != null) select.value = value;
          });
        }

        onVariantChange(card, optionSelects) {
          var ordered = optionSelects.slice().sort(function (a, b) {
            return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
          });
          var values = ordered.map(function (select) {
            return select.value;
          });
          var variant = this.findMatchingVariant(card, values);
          this.applyVariant(card, variant);
          this.updateTotal();
        }

        applyVariant(card, variant) {
          card.dataset.variantId = variant ? variant.id : '';
          card.dataset.available = variant ? String(!!variant.available) : 'false';

          var priceCurrent = card.querySelector('[data-stl-current-price]');
          var priceCompare = card.querySelector('[data-stl-compare-price]');
          var image = card.querySelector('.stl__card-image');
          var addButton = card.querySelector('[data-stl-add]');

          if (variant) {
            if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price, this.moneyFormat);
            if (priceCompare) {
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                priceCompare.textContent = formatMoney(variant.compare_at_price, this.moneyFormat);
                priceCompare.hidden = false;
              } else {
                priceCompare.hidden = true;
              }
            }
            if (image && variant.featured_image && variant.featured_image.src) {
              image.src = variant.featured_image.src;
              image.srcset = '';
            }
          }

          if (addButton) {
            var label = addButton.querySelector('[data-stl-add-label]');
            addButton.dataset.state = '';
            if (!variant) {
              addButton.disabled = true;
              if (label) label.textContent = addButton.dataset.labelUnavailable;
            } else if (!variant.available) {
              addButton.disabled = true;
              if (label) label.textContent = addButton.dataset.labelSoldOut;
            } else {
              addButton.disabled = false;
              if (label) label.textContent = addButton.dataset.labelIdle;
            }
          }
        }

        getCardQuantity(card) {
          var input = card.querySelector('[data-stl-qty-input]');
          return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
        }

        updateTotal() {
          if (!this.totalEl && !this.addAllButton) return;
          var total = 0;
          var validCount = 0;
          var self = this;
          this.cards.forEach(function (card) {
            if (card.dataset.available === 'true' && card.dataset.variantId) {
              var variant = card.__variants.find(function (v) {
                return String(v.id) === card.dataset.variantId;
              });
              if (variant) {
                total += variant.price * self.getCardQuantity(card);
                validCount += 1;
              }
            }
          });
          if (this.totalEl) this.totalEl.textContent = formatMoney(total, this.moneyFormat);
          if (this.addAllButton) this.addAllButton.disabled = validCount === 0;
        }

        clearActive() {
          this.hotspots.forEach(function (hotspot) {
            hotspot.setAttribute('aria-pressed', 'false');
          });
          this.cards.forEach(function (card) {
            card.classList.remove('stl__card--active');
          });
        }

        activate(blockId, options) {
          options = options || {};
          if (!blockId) return;

          this.hotspots.forEach(function (hotspot) {
            hotspot.setAttribute('aria-pressed', String(hotspot.dataset.stlTarget === blockId));
          });
          this.cards.forEach(function (card) {
            card.classList.toggle('stl__card--active', card.dataset.stlId === blockId);
          });

          if (options.scrollCard) {
            var card = this.querySelector('[data-stl-card][data-stl-id="' + CSS.escape(blockId) + '"]');
            if (card) {
              card.scrollIntoView({
                behavior: this.reducedMotion ? 'auto' : 'smooth',
                block: 'nearest',
                inline: 'center',
              });
              card.focus({ preventScroll: true });
            }
          }

          if (options.scrollHotspot && this.imageWrap) {
            var rect = this.imageWrap.getBoundingClientRect();
            var isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
            if (!isVisible) {
              this.imageWrap.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'center' });
            }
          }
        }

        setButtonState(button, state) {
          button.dataset.state = state;
          var label = button.querySelector('[data-stl-add-label]') || button.querySelector('[data-stl-add-all-label]');
          if (!label) return;
          if (state === 'loading') label.textContent = button.dataset.labelLoading;
          else if (state === 'success') label.textContent = button.dataset.labelSuccess;
          else if (state === 'error') label.textContent = button.dataset.labelError;
          else label.textContent = button.dataset.labelIdle;
        }

        finishCartAdd() {
          var self = this;
          return ShopTheLookCart.getCart(this._abortController.signal)
            .then(function (cart) {
              ThemeCartBridge.notify(cart);
              var opened = ThemeCartBridge.openDrawer();
              if (!opened && self.enableFallbackCart) {
                FallbackCartDrawer.open(cart, self.moneyFormat);
              }
            })
            .catch(function () {
              // Cart read-back failed after a successful add; the add itself
              // already succeeded, so this is a best-effort UI refresh only.
            });
        }

        addSingleToCart(card, button) {
          if (button.dataset.loading === 'true') return;
          var variantId = Number(card.dataset.variantId);
          if (!variantId || !Number.isInteger(variantId) || card.dataset.available !== 'true') return;

          var self = this;
          button.dataset.loading = 'true';
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          this.setButtonState(button, 'loading');

          ShopTheLookCart.addItems(
            [{ id: variantId, quantity: this.getCardQuantity(card) }],
            this._abortController.signal
          )
            .then(function () {
              return self.finishCartAdd();
            })
            .then(function () {
              self.setButtonState(button, 'success');
              self.toast(button.dataset.labelSuccess || 'Added to cart', 'success');
              window.location.href = 'https://leopardegy.net/cart';
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              self.setButtonState(button, 'error');
              self.toast((error && error.message) || 'Something went wrong. Please try again.', 'error');
            })
            .finally(function () {
              button.dataset.loading = 'false';
              button.removeAttribute('aria-busy');
              self._setTimeout(function () {
                button.disabled = card.dataset.available !== 'true';
                self.setButtonState(button, 'idle');
              }, 2200);
            });
        }

        addAllToCart() {
          var button = this.addAllButton;
          if (!button || button.dataset.loading === 'true') return;

          var self = this;
          var items = [];
          this.cards.forEach(function (card) {
            var variantId = Number(card.dataset.variantId);
            if (card.dataset.available === 'true' && variantId && Number.isInteger(variantId)) {
              items.push({ id: variantId, quantity: self.getCardQuantity(card) });
            }
          });

          if (!items.length) {
            this.toast('No items available to add', 'error');
            return;
          }

          button.dataset.loading = 'true';
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          this.setButtonState(button, 'loading');

          ShopTheLookCart.addItems(items, this._abortController.signal)
            .then(function () {
              return self.finishCartAdd();
            })
            .then(function () {
              self.setButtonState(button, 'success');
              self.toast(button.dataset.labelSuccess || 'Added to cart', 'success');
              window.location.href = 'https://leopardegy.net/cart';
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              self.setButtonState(button, 'error');
              self.toast((error && error.message) || button.dataset.labelError, 'error');
            })
            .finally(function () {
              button.dataset.loading = 'false';
              button.removeAttribute('aria-busy');
              self._setTimeout(function () {
                button.disabled = false;
                self.setButtonState(button, 'idle');
                self.updateTotal();
              }, 2200);
            });
        }

        toast(message, type) {
          if (!this.toastEl) return;
          var self = this;
          this.toastEl.textContent = message;
          this.toastEl.dataset.type = type || 'success';
          this.toastEl.classList.add('stl__toast--visible');
          if (this.toastTimer) {
            this._timers.delete(this.toastTimer);
            window.clearTimeout(this.toastTimer);
          }
          this.toastTimer = this._setTimeout(function () {
            self.toastEl.classList.remove('stl__toast--visible');
          }, 4000);
        }
      }

      if (!customElements.get('shop-the-look-section')) {
        customElements.define('shop-the-look-section', ShopTheLookSectionElement);
      }
    }

    defineShopTheLookSection();
  })();

  } catch(e) { console.error(e); }
})();
})();
